module.exports = __webpack_public_path__ + "static/template_green-667c7e625f34a1c17fd05273e3953e87.png";